const m = require('minthril');
const { component } = require('../../component');

const Pagination = component(() => ({
  view: ({ attrs: {
    page,
    pageCount,
    itemCount,
    hasPrevious = page > 0,
    hasNext = page + 1 < pageCount,
    loading = false,
    label = 'items',
    onChange
  } }) => {
    if (!hasPrevious && !hasNext) return null;

    return m('nav.list-pagination', { 'aria-label': `${label} pages` }, [
      m('button.button.button--quiet', {
        type: 'button',
        disabled: loading || !hasPrevious,
        onclick: () => onChange(page - 1)
      }, 'Previous'),
      m('span.list-pagination__status.muted', loading
        ? `Loading ${label}…`
        : pageCount
          ? `Page ${page + 1} of ${pageCount} · ${itemCount} ${label}`
          : `Page ${page + 1}${itemCount ? ` · ${itemCount} ${label}` : ''}`),
      m('button.button.button--quiet', {
        type: 'button',
        disabled: loading || !hasNext,
        onclick: () => onChange(page + 1)
      }, 'Next')
    ]);
  }
}));

module.exports = { Pagination };
